/* eslint-disable react/prop-types */
import React from 'react';

import DiscountCardWithDuration from './DiscountCardWithDuration';
import DiscountCardForever from './DiscountCardForever';

// COMPONENT
function PlanDiscountInfo({ stripePlan, discountInfo, isBlackFridayPromo, isNewYearPromo }) {
  if (discountInfo.hasDuration) {
    return (
      <DiscountCardWithDuration
        stripePlan={stripePlan}
        discountInfo={discountInfo}
        isBlackFridayPromo={isBlackFridayPromo}
        isNewYearPromo={isNewYearPromo}
      />
    );
  }
  return (
    <DiscountCardForever
      stripePlan={stripePlan}
      discountInfo={discountInfo}
      isBlackFridayPromo={isBlackFridayPromo}
      isNewYearPromo={isNewYearPromo}
    />
  );
}

export default PlanDiscountInfo;
